(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('MedalBoard', MedalBoard);

    MedalBoard.$inject = ['$resource', 'DateUtils'];

    function MedalBoard ($resource, DateUtils) {
        var resourceUrl =  'api/medal-boards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
